const AUTH_SESSION_KEY = "learnweb_authenticated";
const AUTH_TOKEN_KEY = "learnweb_auth_token";
const AUTH_EMAIL_KEY = "learnweb_auth_email";
const AUTH_CHANGE_EVENT = "learnweb-auth-change";

export function isAuthenticated(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    return window.localStorage.getItem(AUTH_SESSION_KEY) === "true";
}

export function setAuthenticated(email?: string): void {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.setItem(AUTH_SESSION_KEY, "true");
    if (email) {
        window.localStorage.setItem(AUTH_EMAIL_KEY, email);
    }
    window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function setAuthToken(token: string, email?: string): void {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    window.localStorage.setItem(AUTH_SESSION_KEY, "true");
    if (email) {
        window.localStorage.setItem(AUTH_EMAIL_KEY, email);
    }
    window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function getAuthToken(): string | null {
    if (typeof window === "undefined") {
        return null;
    }

    return window.localStorage.getItem(AUTH_TOKEN_KEY);
}

export function getAuthEmail(): string | null {
    if (typeof window === "undefined") {
        return null;
    }

    return window.localStorage.getItem(AUTH_EMAIL_KEY);
}

export function clearAuthenticated(): void {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.removeItem(AUTH_SESSION_KEY);
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    window.localStorage.removeItem(AUTH_EMAIL_KEY);
    window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function getAuthChangeEventName(): string {
    return AUTH_CHANGE_EVENT;
}
